const cardItems = [
  {
    title: '榴莲视频热播：《星辰大海》凭什么成为年度爆款？',
    tag: '剧集推荐',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20of%20modern%20city%20apartment%20interior%20with%20soft%20evening%20light%2C%20cozy%20atmosphere%2C%20film%20photography%20style%2C%20golden%20hour%20ambient%20lighting%2C%20urban%20drama%20aesthetic%2C%20professional%20cinematography%2C%20no%20text%20no%20people&width=800&height=480&seq=card-section-01&orientation=landscape',
    desc: '都市情感题材再出爆款，口碑与热度齐飞，成为今年最受瞩目的电视剧之一。',
  },
  {
    title: '红杏视频古装大剧《长安夜未央》深度解析',
    tag: '深度解读',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20lantern%20and%20silk%20decorations%20in%20warm%20candlelight%2C%20ancient%20palace%20interior%20details%2C%20historical%20drama%20aesthetic%2C%20rich%20cultural%20atmosphere%2C%20soft%20golden%20glow%2C%20professional%20set%20photography%2C%20ornate%20traditional%20design%2C%20no%20text%20no%20people&width=800&height=480&seq=card-section-02&orientation=landscape',
    desc: '服化道精良、演技在线，这部古装剧如何成为现象级作品？一起来看深度解析。',
  },
  {
    title: '悬疑迷必看：《迷雾追踪2》烧脑升级口碑炸裂',
    tag: '新季开播',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20urban%20alley%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20film%20noir%20atmosphere%2C%20suspenseful%20cinematic%20lighting%2C%20dark%20shadows%20with%20amber%20highlights%2C%20professional%20thriller%20photography%2C%20moody%20composition%2C%20no%20text%20no%20people&width=800&height=480&seq=card-section-03&orientation=landscape',
    desc: '第二季剧情更加扑朔迷离，高分悬疑剧终于回归，网友直呼：太上头了！',
  },
  {
    title: '国漫崛起之年：向日葵视频动漫专区片库解读',
    tag: '动漫专题',
    cover: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20background%20with%20warm%20lighting%2C%20vibrant%20digital%20art%2C%20fantasy%20landscape%20with%20golden%20sunset%20sky%2C%20animation%20style%20clouds%2C%20creative%20artistic%20composition%2C%20professional%20digital%20painting%2C%20no%20text%20no%20characters&width=800&height=480&seq=card-section-04&orientation=landscape',
    desc: '国产动漫迎来黄金时代，向日葵视频动漫专区为你盘点最值得看的国漫佳作。',
  },
  {
    title: '家庭影院指南：向日葵视频4K超清观影体验',
    tag: '观影指南',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20room%20with%20large%20screen%20and%20warm%20ambient%20lighting%2C%20cozy%20entertainment%20setup%2C%20cinematic%20viewing%20environment%2C%20soft%20indirect%20lighting%2C%20premium%20audio%20equipment%2C%20comfortable%20seating%20area%2C%20professional%20interior%20photography%2C%20no%20text%20no%20people&width=800&height=480&seq=card-section-05&orientation=landscape',
    desc: '如何在家享受影院级观影？向日葵视频4K专区搭配大屏设备，效果惊艳。',
  },
  {
    title: '综艺控福利：榴莲视频《欢乐集结号》笑点合集',
    tag: '综艺精选',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20stage%20lighting%20with%20warm%20spotlights%2C%20variety%20show%20studio%20set%2C%20entertainment%20production%20environment%2C%20vibrant%20atmosphere%2C%20professional%20broadcast%20lighting%20design%2C%20golden%20and%20amber%20stage%20decor%2C%20no%20text%20no%20people&width=800&height=480&seq=card-section-06&orientation=landscape',
    desc: '爆笑不断的综艺节目，嘉宾阵容豪华，每一期都有意想不到的欢乐桥段。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频编辑团队为你甄选优质影视内容与观影指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug font-heading line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs text-primary-600 font-medium">
                  <span>阅读全文</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}